import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router';
import { ButtonProps } from 'react-bootstrap/Button';

export type LinkButtonStyleProps = Pick<ButtonProps, 'size' | 'variant'>;

export interface LinkButtonProps extends LinkButtonStyleProps, LinkProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

const BOOTSTRAP_BUTTON_PREFIX = 'btn';

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>((props, ref) => {
  const { className, isActive, isDisabled, size, variant = 'primary', ...linkProps } = props;

  const bsClassnames = classNames(className, BOOTSTRAP_BUTTON_PREFIX, {
    active: isActive,
    disabled: isDisabled,
    [`${BOOTSTRAP_BUTTON_PREFIX}-${size}`]: size,
    [`${BOOTSTRAP_BUTTON_PREFIX}-${variant}`]: variant,
  });

  return <Link ref={ref} className={bsClassnames} {...linkProps} />;
});

LinkButton.displayName = 'LinkButton';
